/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AvailableLegalNoticesAttributeType
 */
export interface AvailableLegalNoticesAttributeType {
    /**
     * 
     * @type {string}
     * @memberof AvailableLegalNoticesAttributeType
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableLegalNoticesAttributeType
     */
    example?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableLegalNoticesAttributeType
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableLegalNoticesAttributeType
     */
    name: string;
}

/**
 * Check if a given object implements the AvailableLegalNoticesAttributeType interface.
 */
export function instanceOfAvailableLegalNoticesAttributeType(value: object): value is AvailableLegalNoticesAttributeType {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AvailableLegalNoticesAttributeTypeFromJSON(json: any): AvailableLegalNoticesAttributeType {
    return AvailableLegalNoticesAttributeTypeFromJSONTyped(json, false);
}

export function AvailableLegalNoticesAttributeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableLegalNoticesAttributeType {
    if (json == null) {
        return json;
    }
    return {
        
        'category': json['category'] == null ? undefined : json['category'],
        'example': json['example'] == null ? undefined : json['example'],
        'label': json['label'] == null ? undefined : json['label'],
        'name': json['name'],
    };
}

export function AvailableLegalNoticesAttributeTypeToJSON(value?: AvailableLegalNoticesAttributeType | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'category': value['category'],
        'example': value['example'],
        'label': value['label'],
        'name': value['name'],
    };
}

